module.exports = __webpack_public_path__ + "img/icon-512x512.55a7c2c1.png";